import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import { useLeftHandLayout } from 'components/LeftHandLayout';

const PageLayoutInsetContent = ({ children, sx, ...rest }: StackProps) => {
	const { topInnerX } = useLeftHandLayout();

	return (
		<Stack
			sx={combineSx(
				{
					paddingX: { xs: `${topInnerX}px`, md: 0 },
				},
				sx,
			)}
			{...rest}
		>
			{children}
		</Stack>
	);
};

export default PageLayoutInsetContent;
